<template>
  <div class="addressSelect">
    <Select
      :id="props.data.id"
      v-model="selectedItem"
      :loading="addressesFull === 'loading'"
      filter
      :options="addressesList"
      option-label="name"
      :placeholder="$t('pleaseSelect')"
      :class="[props.data.errorMessage ? 'invalid' : 'valid', props.data.elementClasses ]"
      :invalid="props.data.errorMessage ? true : false"
      :disabled="props.data.disabled"
      class="w-full"
      option-disabled="disabled"
      @change="($event) => {
        chooseAddress($event)
      }"
    />
  </div>
</template>

<script setup>
const { $i18n: i18n } = useNuxtApp()
const { addressesFull, getAddresses } = useCustomerAddresses({ key: 'full' })
const { drawerOptions } = usePopups()

const selectedItem = ref(null)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnData'])

/**
* Get Addresses
*/
if (addressesFull.value !== 'loading' && !addressesFull.value.data) {
  getAddresses({
    limit: 10000
  }, {
    fullList: true,
    simple: true
  })
}

/**
* Addresses
*/
const addressesList = computed({
  get() {
    const newArr = [
      {
        disabled: false,
        code: 'new_address',
        name: i18n?.t('addNewAddress')
      }
    ]
    
    if (addressesFull.value.data) {
      addressesFull.value.data.addresses.forEach((item) => {
        newArr.push({
          disabled: props.data.disabledSelectOptions
            ? !!(props.data.disabledSelectOptions?.find(n => n * 1 === item.address_id * 1) && item.address_id * 1 !== props.data.formData[props.data.name] * 1)
            : false,
          code: item.address_id * 1,
          name: item.fullAddress,
          default: item.default === 'true'
        })
      })
    }

    return newArr
  }
})

/**
* Current Address
*/
const selectAddress = () => { 
  if (!selectedItem.value) {
    if (!props.data.formData[props.data.name] && props.data.formData[props.data.secondName] && addressesList.value.find(n => n.name.includes(props.data.formData[props.data.secondName]))) { 
      selectedItem.value = addressesList.value.find(n => n.name.includes(props.data.formData[props.data.secondName]))

      emit('returnData', selectedItem.value.code * 1)
    } else if (addressesList.value.find(n => n.code === props.data.formData[props.data.name] * 1) && selectedItem.value?.code !== props.data.formData[props.data.name] * 1) {
      selectedItem.value = addressesList.value.find(n => n.code === props.data.formData[props.data.name] * 1)
    }
  }
}

selectAddress()
watch(addressesList, () => {
  selectAddress()
}, { deep: true })

/**
* Choose Address
*/
const chooseAddress = () => {
  if (selectedItem.value.code === 'new_address') {
    if (addressesList.value?.find(n => n.code === props.data.formData[props.data.name] * 1)) {
      selectedItem.value = addressesList.value.find(n => n.code === props.data.formData[props.data.name] * 1)
    } else {
      selectedItem.value = addressesList.value[0]
    }

    // Open Panel Address Form
    drawerOptions.value.address = {
      typeId: 'address',
      componentId: 'FormsGroupAddress',
      header: i18n?.t('addNewAddress'),
      returnData: async (id) => {
        await getAddresses({
          limit: 10000
        }, {
          fullList: true,
          simple: true
        }).then(() => {
          setTimeout(() => {
            selectedItem.value = addressesList.value?.find(n => n.code === id * 1)

            emit('returnData', selectedItem.value.code * 1)
          }, 100)
        })
      }
    }
  } else {
    emit('returnData', selectedItem.value.code * 1)
  }
}
</script>

<style lang="scss" scoped>
</style>
